import React, { useState } from "react";
import classes from "./Tooltip.module.scss";

const Tooltip = ({
  delay,
  show = true,
  direction = "top",
  content,
  children,
}) => {
  let timeout;
  const [active, setActive] = useState(false);
  let directionClass =
    direction === "top"
      ? classes.tooltip__tip__top
      : direction === "bottom"
      ? classes.tooltip__tip__bottom
      : direction === "left"
      ? classes.tooltip__tip__left
      : direction === "right"
      ? classes.tooltip__tip__right
      : classes.tooltip__tip__top;
  const showTip = () => {
    timeout = setTimeout(() => {
      setActive(true);
    }, delay || 200);
  };

  const hideTip = () => {
    clearInterval(timeout);
    setActive(false);
  };

  return (
    <div
      className={classes.tooltip__wrapper}
      onMouseEnter={showTip}
      onMouseLeave={hideTip}
    >
      {children}
      {active && show && (
        <div className={`${classes.tooltip__tip} ${directionClass}`}>
          {content}
        </div>
      )}
    </div>
  );
};

export default Tooltip;
